import { DEFAULT_COLUMN_WIDTH, type TGridFieldKeys } from "../constants";

export const mapTableColumnWidth: Partial<Record<TGridFieldKeys, number>> = {
  address: DEFAULT_COLUMN_WIDTH,
  booking_status: 110,
  feedback_status: 150,
  feedbacks_count: 70,
  ride_ml_path_indicator: 110,
  ride_passengers_csv_list: DEFAULT_COLUMN_WIDTH,
  checkbox: 70,
  course_schedule: DEFAULT_COLUMN_WIDTH,
  course_stations: DEFAULT_COLUMN_WIDTH,
  csv_list: DEFAULT_COLUMN_WIDTH,
  warnings_display: 56,
  currency: 75,
  date: 145,
  date_range: DEFAULT_COLUMN_WIDTH,
  date_with_indicator: DEFAULT_COLUMN_WIDTH,
  datetime: 170,
  datetime_compact_readonly: 82,
  datetime_range: DEFAULT_COLUMN_WIDTH,
  direction: 120,
  dropdown_bound_text: DEFAULT_COLUMN_WIDTH,
  email: DEFAULT_COLUMN_WIDTH,
  number: 70,
  phone: 140,
  ride_status: 120,
  switch: 45,
  switch_alternative: 90,
  switch_confirm: 90,
  tags: DEFAULT_COLUMN_WIDTH,
  text: 120,
  time: 80,
  time_range: DEFAULT_COLUMN_WIDTH,
  url: DEFAULT_COLUMN_WIDTH,
  vehicle_occupancy: 70,
  complaint_status: 110,
  notification_priority: 110,
  entity_name: 120,
  entity_link: 120,
  plain_text: DEFAULT_COLUMN_WIDTH,
  hub_stations_grid_template: DEFAULT_COLUMN_WIDTH,
  booking_hub_grid_template: 180,
  hidden_field: 0,
  live_map_arrival_delay: 118,
  live_map_delay_status: 110,
  live_map_ride_start_status: 110,
  ride_route_completion_status: 130,
  boolean_image_icon: 56,
} as const;
